/** Parse quantity from form text (never use string + number addition on raw inputs). */
export function parseQuantityInput(raw: string | undefined | null): number {
  if (raw == null) return 0;
  const t = String(raw).trim().replace(/\s/g, "").replace(/,/g, ".");
  if (t === "" || t === ".") return 0;
  const n = Number.parseFloat(t);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.round(n * 10000) / 10000;
}

/** Keep only one decimal separator while typing. */
export function sanitizeQtyFieldInput(raw: string): string {
  const s = raw.replace(/[^\d.,]/g, "").replace(/,/g, ".");
  const firstDot = s.indexOf(".");
  if (firstDot === -1) return s;
  return s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, "");
}
